<template>

  <div id="wrapper" v-if="project">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}"> Dashboard</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: projectId}}">Project Overview</router-link></li>
              <li class="active">
                <span v-if="project.workflow_id === 3">Tech offer</span>
                <span v-else>Question</span>

              </li>
            </ol>
          </div>
          <template v-if="project.workflow_id === 3">
            <h3 class="font-light m-b-xs">
              Edit Tech offer - <router-link :to="{name: 'ProjectDetails', params: {id: project.id}}" class="text-info font-bold">{{project.name}}</router-link>
            </h3>
            <small>Articulate Tech offer to be sent to Experts</small>
          </template>
          <template v-else>
            <h3 class="font-light m-b-xs">
              Edit Question - <router-link :to="{name: 'ProjectDetails', params: {id: project.id}}" class="text-info font-bold">{{project.name}}</router-link>
            </h3>
            <small>Articulate question to be sent to Experts</small>
          </template>
        </div>
      </div>
    </div>

    <div class="content">

      <form ref="form" action="#" method="post" id="" v-on:submit="submitForm">

        <div class="row">
          <div class="col-lg-12">
            <div class="hpanel">
              <div class="panel-heading">
                <template v-if="project.workflow_id === 3">
                  Tech offer overview
                </template>
                <template v-else>
                  Question overview
                </template>
              </div>
              <div class="panel-body">

                <question-step1 ref="step1" :question="questionStep1" :projectId="projectId" :workflowId="project.workflow_id" @update-long-description="updateLongDescription"/>
              </div>
            </div>
          </div>
        </div>
        <template v-if="questionId">

          <div class="row">
            <div class="col-lg-12">
              <div class="hpanel">
                <div class="panel-heading">
                  <template v-if="project.workflow_id === 3">
                    Tech offer details
                  </template>
                  <template v-else>
                    Question details
                  </template>
                </div>
                <div class="panel-body">

                  <question-step2 ref="step2" v-model="refreshFiles" :question="questionStep2" :projectId="projectId" :workflowId="project.workflow_id" />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="hpanel">
                <div class="panel-heading">
                  <template v-if="project.workflow_id === 3">
                    Promoting the Tech offer
                  </template>
                  <template v-else>
                    Promoting the Question
                  </template>
                </div>
                <div class="panel-body">
                  <question-step3 ref="step3" v-model="refreshPicture" :question="questionStep3" :projectId="projectId" :workflowId="project.workflow_id" />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="hpanel">
                <div class="panel-heading">
                  <template v-if="project.workflow_id === 3">
                    Tech offer preferences – this information is not disclosed
                  </template>
                  <template v-else>
                    Question preferences – this information is not disclosed
                  </template>
                </div>
                <div class="panel-body">
                  <question-step4 ref="step4" :question="questionStep4" :projectId="projectId" />
                </div>
              </div>
            </div>
          </div>

        </template>

        <div class="row" style="margin-bottom: 10px">
          <template v-if="questionId">
            <div class="col-xs-6">
              <div class="text-center">
                <vue-ladda type="input" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" @click="submit.name = 'validate'">Save & Validate</vue-ladda>
              </div>
            </div>
            <div class="col-xs-6">
              <form v-on:submit="submitForm">
                <div class="text-center">
                  <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" @click="submit.name = 'quit'">Save Draft</vue-ladda>
                </div>
              </form>
            </div>
          </template>
          <template v-else>
            <div class="col-xs-12">
              <div class="text-center">
                <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" @click="submit.name = 'quit'">Save Draft</vue-ladda>
              </div>
            </div>
          </template>

        </div>

      </form>

    </div>
  </div>
</template>

<script>
import QuestionStep1 from '../../components/question/QuestionStep1'
import QuestionStep2 from '../../components/question/QuestionStep2'
import QuestionStep3 from '../../components/question/QuestionStep3'
import QuestionStep4 from '../../components/question/QuestionStep4'
import VueLadda from 'vue-ladda'

export default {
  components: {
    QuestionStep4,
    QuestionStep3,
    QuestionStep2,
    QuestionStep1,
    VueLadda},
  name: 'QuestionEdit',
  props: [],
  data () {
    return {
      questionStep1: {
        id: null,
        title: null,
        company_profile: null,
        objective: null,
        issue: null,
        restraint: null,
        expert_interest: null
      },
      questionStep2: {
        id: null,
        long_description: null,
        metrics: [],
        trl: null,
        timeline: null,
        maturities: null,
        proposal_requests: null,
        files: [],
        start_date: null,
        end_date: null
      },
      questionStep3: {
        id: null,
        reward_descr: null,
        keywords: null,
        picture: null,
        is_public: true
      },
      questionStep4: {
        id: null,
        nb_response: null,
        known_companies: null,
        excluded_companies: null,
        exclude_country: null,
        preferred_country: null
      },
      projectId: null,
      questionId: null,
      project: null,
      refreshFiles: false,
      refreshPicture: false,
      submit: {
        loading: false,
        name: name,
        'dataStyle': 'zoom-in'
      },
      requiredFields: true

    }
  },
  watch: {
    'questionStep1.id': function (val) {
      this.questionId = val
      this.questionStep2.id = val
      this.questionStep3.id = val
      this.questionStep4.id = val
    },
    refreshFiles: function (val) {
      if (this.questionId !== null) {
        this.axios.get('/question/' + this.questionId)
          .then((response) => {
            this.questionStep2.files = response.data.files
          })
      }
    },
    refreshPicture: function (val) {
      if (this.questionId !== null) {
        this.axios.get('/question/' + this.questionId)
          .then((response) => {
            this.questionStep3.picture = response.data.picture
          })
      }
    }
  },
  methods: {
    submitForm: function (e) {
      e.preventDefault()

      let requiredFields = this.submit.name !== 'quit'

      this.submit.loading = true

      if (this.questionId === null) {
        this.$refs.step1.submitStep()
          .then((response) => {
            this.questionStep1.id = response.data.id

            this.$router.replace({ name: this.$route.name, params: {question_id: response.data.id}})
            this.$salesMachine.createDraftQuestion({question_id: response.data.id, question: response.data.title})
          }).catch((error) => {
            this.$notify({
              type: 'danger',
              title: 'Please fill all the mandatory fields',
              content: '',
              placement: 'bottom-right'
            })
          }).finally(() => {
            this.submit.loading = false
          })
      } else {
        if (this.questionId !== null) {
          this.axios.all([
            this.$refs.step1.submitStep(requiredFields),
            this.$refs.step2.submitStep(requiredFields),
            this.$refs.step3.submitStep(requiredFields),
            this.$refs.step4.submitStep(requiredFields)]
          ).then(this.axios.spread(() => {
            if (this.submit.name === 'quit') {
              this.$router.push({name: 'ProjectDetails', params: {id: this.projectId}})
              this.$salesMachine.createDraftQuestion({question_id: this.questionId, project_id: this.projectId})
            } else if (this.submit.name === 'validate') {
              this.$router.push({name: 'QuestionReview', params: {id: this.questionId}})
              this.$salesMachine.createQuestion({question_id: this.questionId, project_id: this.projectId})
            }
          })).catch((error) => {
            this.$notify({
              type: 'danger',
              title: 'Please fill all the mandatory fields',
              content: '',
              placement: 'bottom-right'
            })
          }).finally(() => {
            this.submit.loading = false
          })
        }
      }
    },
    getResources: function () {
      if (this.questionId !== null) {
        this.axios.get('/question/' + this.questionId)
          .then((response) => {
            let question = response.data

            if ((this.$auth.check('basic') || this.$auth.check('seeker')) && question.status_id > 2) {
              this.$router.replace({name: 'Error403', params: { '0': ''}})
            }

            this.questionStep1.id = question.id
            this.questionStep1.title = question.title
            this.questionStep1.company_profile = question.company_profile
            this.questionStep1.objective = question.objective
            this.questionStep1.issue = question.issue
            this.questionStep1.restraint = question.restraint
            this.questionStep1.expert_interest = question.expert_interest

            this.questionStep2.id = question.id
            this.questionStep2.long_description = question.long_description
            this.questionStep2.metrics = question.metrics
            this.questionStep2.trl = question.trl
            this.questionStep2.timeline = question.timeline
            this.questionStep2.maturities = question.maturities
            this.questionStep2.proposal_requests = question.proposal_requests
            this.questionStep2.files = question.files
            this.questionStep2.start_date = question.start_date
            this.questionStep2.end_date = question.end_date

            this.questionStep3.id = question.id
            this.questionStep3.reward_descr = question.reward_descr
            this.questionStep3.keywords = question.keywords
            this.questionStep3.picture = question.picture
            this.questionStep3.is_public = question.is_public

            this.questionStep4.id = question.id
            this.questionStep4.nb_response = question.nb_response
            this.questionStep4.known_companies = question.known_companies
            this.questionStep4.excluded_companies = question.excluded_companies
            this.questionStep4.preferred_country = question.preferred_country
            this.questionStep4.exclude_country = question.exclude_country
            this.questionStep4.is_paid = question.is_paid
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      }
      if (this.projectId !== null) {
        this.axios.get('/project/' + this.projectId)
          .then((response) => {
            this.project = response.data
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      }
    },
    updateLongDescription (challengeDetails) {
      this.questionStep2.long_description = challengeDetails
    }
  },
  beforeMount () {
    this.projectId = this.$route.params.project_id
    this.questionId = typeof this.$route.params.question_id !== 'undefined' ? this.$route.params.question_id : null
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/question/QuestionEdit.vue